import BarChart from "@cloudscape-design/components/bar-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import { Link } from "@cloudscape-design/components";

export const SkyscraperGraph = () => {
  function numberFormatter(y: number) {
    if (Math.abs(y) >= 1e9) {
      return (y / 1e9).toFixed(1).replace(/\.0$/, "") + "G";
    }
    if (Math.abs(y) >= 1e6) {
      return (y / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
    }
    if (Math.abs(y) >= 1e3) {
      return (y / 1e3).toFixed(1).replace(/\.0$/, "") + "K";
    }
    return y.toFixed(2);
  }

  return (
    <BarChart
      series={[
        {
          title: "United States",
          type: "bar",
          data: [
            { x: 2000, y: 65 },
            { x: 2005, y: 94 },
            { x: 2010, y: 125 },
            { x: 2015, y: 192 },
            { x: 2025, y: 300 },
          ],
          valueFormatter: function l(e) {
            return Math.abs(e) >= 1e9
              ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "G"
              : Math.abs(e) >= 1e6
              ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
              : Math.abs(e) >= 1e3
              ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
              : e.toFixed(2);
          },
        },
        {
          title: "United Arab Emirates",
          type: "bar",
          data: [
            { x: 2000, y: 3 },
            { x: 2005, y: 9 },
            { x: 2010, y: 42 },
            { x: 2015, y: 112 },
            { x: 2025, y: 240 },
          ],
          valueFormatter: function l(e) {
            return Math.abs(e) >= 1e9
              ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "G"
              : Math.abs(e) >= 1e6
              ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
              : Math.abs(e) >= 1e3
              ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
              : e.toFixed(2);
          },
        },
        {
          title: "Malaysia",
          type: "bar",
          data: [
            { x: 2000, y: 3 },
            { x: 2005, y: 9 },
            { x: 2010, y: 25 },
            { x: 2015, y: 64 },
            { x: 2025, y: 120 },
          ],
          valueFormatter: function l(e) {
            return Math.abs(e) >= 1e9
              ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "G"
              : Math.abs(e) >= 1e6
              ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
              : Math.abs(e) >= 1e3
              ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
              : e.toFixed(2);
          },
        },
        {
          title: "Japan",
          type: "bar",
          data: [
            { x: 2000, y: 13 },
            { x: 2005, y: 19 },
            { x: 2010, y: 25 },
            { x: 2015, y: 48 },
            { x: 2025, y: 90 },
          ],
          valueFormatter: function l(e) {
            return Math.abs(e) >= 1e9
              ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "G"
              : Math.abs(e) >= 1e6
              ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
              : Math.abs(e) >= 1e3
              ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
              : e.toFixed(2);
          },
        },
        {
          title: "South Korea",
          type: "bar",
          data: [
            { x: 2000, y: 3 },
            { x: 2005, y: 7 },
            { x: 2010, y: 17 },
            { x: 2015, y: 48 },
            { x: 2025, y: 120 },
          ],
          valueFormatter: function l(e) {
            return Math.abs(e) >= 1e9
              ? (e / 1e9).toFixed(1).replace(/\.0$/, "") + "G"
              : Math.abs(e) >= 1e6
              ? (e / 1e6).toFixed(1).replace(/\.0$/, "") + "M"
              : Math.abs(e) >= 1e3
              ? (e / 1e3).toFixed(1).replace(/\.0$/, "") + "K"
              : e.toFixed(2);
          },
        },
      ]}
      xDomain={[2000, 2005, 2010, 2015, 2025]}
      yDomain={[0, 370]}
      detailPopoverSeriesContent={({ series, y }) => {
        const formattedValue = numberFormatter(y);
        return {
          key: series.title,
          value: (
            <Link
              external
              href="#"
              ariaLabel={`See details for ${formattedValue} on ${series.title} (opens in a new tab)`}
            >
              {formattedValue}
            </Link>
          ),
        };
      }}
      ariaLabel="Multiple data series line chart"
      height={300}
      xTitle="Year"
      yTitle="Number of sky scrapers (buildings ≥ 492 feet or 150 meters)"
      empty={
        <Box textAlign="center" color="inherit">
          <b>No data available</b>
          <Box variant="p" color="inherit">
            There is no data available
          </Box>
        </Box>
      }
      noMatch={
        <Box textAlign="center" color="inherit">
          <b>No matching data</b>
          <Box variant="p" color="inherit">
            There is no matching data to display
          </Box>
          <Button>Clear filter</Button>
        </Box>
      }
      hideFilter
    />
  );
};
